import { render, staticRenderFns } from "./LoaderRound.vue?vue&type=template&id=49cc0eb0&scoped=true&"
import script from "./LoaderRound.vue?vue&type=script&lang=js&"
export * from "./LoaderRound.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRound.vue?vue&type=style&index=0&id=49cc0eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc0eb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cc0eb0')) {
      api.createRecord('49cc0eb0', component.options)
    } else {
      api.reload('49cc0eb0', component.options)
    }
    module.hot.accept("./LoaderRound.vue?vue&type=template&id=49cc0eb0&scoped=true&", function () {
      api.rerender('49cc0eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/components/LoaderRound.vue"
export default component.exports